import React, { useState, useEffect } from 'react';
import { Navbar as BootstrapNavbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import '../../assets/styles/global.css';
import { IMAGES } from '../../assets/image';
import { CREDIT_UNION } from '../../assets/constants';
import { applyLanguage } from './translation';

const Navbar = () => {
  const [expanded, setExpanded] = useState(false);
  const [language, setLanguage] = useState('en');
  const location = useLocation();
  const navigate = useNavigate();

  const hideApplyLink = location.pathname.toLowerCase().includes('/applicationform');

  // Detect current language from cookie ONCE and apply only what's needed.
  useEffect(() => {
    const cookie = document.cookie.split('; ').find(c => c.startsWith('googtrans='));
    const detected = cookie ? cookie.split('=')[1].split('/')[2] : 'en';
    const lang = detected === 'es' ? 'es' : 'en';
    setLanguage(lang);

    // For English, ensure translation is fully disabled.
    // if (lang === 'en') applyLanguage('en');
  }, []);

  // Hide Google banner if it appears (belt & suspenders)
  useEffect(() => {
    const hideBanner = setInterval(() => {
      const banner = document.querySelector('.goog-te-banner-frame');
      if (banner) {
        banner.style.display = 'none';
        document.body.style.top = '0px';
        clearInterval(hideBanner);
      }
    }, 250);
    return () => clearInterval(hideBanner);
  }, []);

  const handleLanguageChange = (e) => {
    const lang = e.target.value; // 'en' | 'es'
    setLanguage(lang);
    applyLanguage(lang); // cookie + (reload for non-EN) handled inside
  };

  const handleApplyNow = () => {
    localStorage.removeItem('current_guid');
    localStorage.removeItem('form_data');
    sessionStorage.clear();
    navigate('/ApplicationForm');
  };


  return (
    <BootstrapNavbar
      expand="lg"
      fixed="top"
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
      aria-label="Main navigation"
      className="navbar-custom"
    >
      <Container className="navbar-inner layout-container d-flex align-items-center">
        <BootstrapNavbar.Brand as={Link} to={CREDIT_UNION.LINKS.WEBSITE} aria-label="Credit Union">
          <img src={IMAGES.Logo} alt="Credit Union Logo" className="navbar-logo" />
        </BootstrapNavbar.Brand>

        <BootstrapNavbar.Toggle aria-controls="navbarNav" />

        <BootstrapNavbar.Collapse id="navbarNav">
          <Nav className="ms-auto navbar-links" role="navigation">
            <Nav.Link
              className="nav-link"
              onClick={() => {
                if (location.pathname !== '/') {
                  navigate('/#about');
                } else {
                  document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              About Us
            </Nav.Link>

            {!hideApplyLink && (
              <Nav.Link as={Link} to="/ApplicationForm" onClick={handleApplyNow} className="nav-link">
                Apply
              </Nav.Link>
            )}

            <Nav.Link
              className="nav-link"
              onClick={() => {
                if (location.pathname !== '/') {
                  navigate('/#faq');
                } else {
                  document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              FAQs
            </Nav.Link>

            <div className="translate-container">
              <select
                value={language}
                onChange={handleLanguageChange}
                className="form-control translate-select"
                aria-label="Select Language"
              >
                <option value="en">English</option>
                <option value="es">Español</option>
              </select>
              <div id="google_translate_element" style={{ display: 'none' }} />
            </div>
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;
